/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobAcceptedResponseFromDiscriminatorValue, serializeImageHousekeepingCleanUpRequest, serializeJobAcceptedResponse, type ErrorResponse, type ImageHousekeepingCleanUpRequest, type InternalErrorResponse, type JobAcceptedResponse } from '../../../../models/index.js';
// @ts-ignore
import { ProgressRequestBuilderNavigationMetadata, type ProgressRequestBuilder } from './progress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/housekeeping/clean-up
 */
export interface CleanUpRequestBuilder extends BaseRequestBuilder<CleanUpRequestBuilder> {
    /**
     * The progress property
     */
    get progress(): ProgressRequestBuilder;
    /**
     * Moves the given abandoned assets to the trash, where the platform stops using them but they stay recoverable until the retention purge. Every id is re-validated server-side against the caller's organization, its image documents and its flipbook references - the submitted selection can never trash a live asset or another organization's. The clean-up is queued and this returns immediately with a tracking id; poll the returned status URI for the per-reason outcome.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobAcceptedResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ImageHousekeepingCleanUpRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobAcceptedResponse | undefined>;
    /**
     * Moves the given abandoned assets to the trash, where the platform stops using them but they stay recoverable until the retention purge. Every id is re-validated server-side against the caller's organization, its image documents and its flipbook references - the submitted selection can never trash a live asset or another organization's. The clean-up is queued and this returns immediately with a tracking id; poll the returned status URI for the per-reason outcome.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ImageHousekeepingCleanUpRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CleanUpRequestBuilderUriTemplate = "{+baseurl}/api/images/housekeeping/clean-up";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CleanUpRequestBuilderNavigationMetadata: Record<Exclude<keyof CleanUpRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    progress: {
        navigationMetadata: ProgressRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CleanUpRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CleanUpRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobAcceptedResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeImageHousekeepingCleanUpRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
